import { Box } from "@mui/material";
import React, { useEffect } from "react";
import UploadProductImagesNew from "../../../components/Form/UploadProductImagesNew";
import CustomTextField from "../../../components/Form/CustomTextField";

export default function UploadMedia({ formObj, handleFormChange, setNotification, windowWidth, error }) {
    const handleSetThumbnail = (file, index) => {
        const updatedPhotos = (formObj?.photos || []).map((photo, photoIndex) => ({
            ...photo,
            is_thumbnail: file?.is_thumbnail ? false : photoIndex === index,
        }));

        if (!updatedPhotos[index]) {
            return;
        }

        handleFormChange('photos', updatedPhotos);
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    return (
        <React.Fragment>
            {/* {error?.images && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.images || ""}</FormHelperText>} */}
            {/* <Box mt={2}>
                <div className="text-semibold">Thumbnail image</div>
                <UploadProductImagesNew
                    showLimit={false}
                    displayFiles={false}
                    values={formObj?.thumbnail_image}
                    setFormValues={(e) => handleFormChange('thumbnail_image', e)}
                    maxFile={1}
                    maxFileSize={10}
                    multiple={false}
                    setNotification={setNotification}
                    images={true}
                    windowWidth={windowWidth}
                    isThumbnail={true}
                />
            </Box> */}
            <Box mt={2}>
                <div className="text-semibold">Upload Photos</div>
                <div className="subheader-2">Up to 10 images of your motorcycle’s photos</div>
                <UploadProductImagesNew
                    showLimit={false}
                    displayFiles={false}
                    values={formObj?.photos}
                    setFormValues={(e) => handleFormChange('photos', e)}
                    maxFile={10}
                    maxFileSize={10}
                    md={3}
                    sm={6}
                    xs={12}
                    multiple={true}
                    setNotification={setNotification}
                    images={true}
                    windowWidth={windowWidth}
                    handleThumbnail={handleSetThumbnail}
                />
            </Box>
            <Box mt={2}>
                <div className="text-semibold">Video URLs <span className="optional-label me-2">Optional</span></div>
                <CustomTextField
                    title={'Youtube'}
                    placeholder={'Youtube Url'}
                    values={formObj?.youtube_url}
                    onChange={(e) => handleFormChange('youtube_url', e)}
                    error={error?.youtube_url}
                />
                <div className="mt-2">
                    <CustomTextField
                        title={'Facebook'}
                        placeholder={'Facebook Url'}
                        values={formObj?.facebook_url}
                        onChange={(e) => handleFormChange('facebook_url', e)}
                        error={error?.facebook_url}
                    />
                </div>
                <div className="mt-2">
                    <CustomTextField
                        title={'Instagram'}
                        placeholder={'Instagram Url'}
                        values={formObj?.instagram_url}
                        onChange={(e) => handleFormChange('instagram_url', e)}
                        error={error?.instagram_url}
                    />
                </div>
                <div className="mt-2">
                    <CustomTextField
                        title={'TikTok'}
                        placeholder={'TikTok Url'}
                        values={formObj?.tiktok_url}
                        onChange={(e) => handleFormChange('tiktok_url', e)}
                        error={error?.tiktok_url}
                    />
                </div>
            </Box>
        </React.Fragment>
    )
}